// extracted by mini-css-extract-plugin
module.exports = {"DevelopmentWithWbObserver":"development-with-wb-observer_DevelopmentWithWbObserver__xbPNb"};